module.exports = " <tb-modal :active=active> <div class=Done> <div class=Done-text>{{praises[praiseIndex]}}</div> <tb-button @click=nextSection v-el:next>Next Section →</tb-button> </div> </tb-modal> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Done.vue
// module id = 123
// module chunks = 2